import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ORGANIZATIONS_KEYS } from '@/features/organizations/public';
import { invitationsService } from '../api/invitations.service';
import { MY_INVITATIONS_KEYS } from './queryKeys';

/** Accepts an invitation by token (email-link flow). */
export function useAcceptInvitation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (token: string) => invitationsService.acceptInvitation({ token }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MY_INVITATIONS_KEYS.all });
      queryClient.invalidateQueries({ queryKey: ORGANIZATIONS_KEYS.all });
    },
  });
}

/** Accepts a pending invitation by ID (in-app flow). */
export function useAcceptInvitationById() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (invitationId: string) => invitationsService.acceptInvitationById(invitationId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MY_INVITATIONS_KEYS.all });
      queryClient.invalidateQueries({ queryKey: ORGANIZATIONS_KEYS.all });
    },
  });
}

/** Rejects a pending invitation by ID (in-app flow). */
export function useRejectInvitation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (invitationId: string) => invitationsService.rejectInvitation(invitationId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MY_INVITATIONS_KEYS.all });
    },
  });
}

/** Rejects an invitation by token (email-link flow). */
export function useRejectInvitationByToken() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (token: string) => invitationsService.rejectInvitationByToken(token),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MY_INVITATIONS_KEYS.all });
    },
  });
}
